import type { FireAnalyticsEvent } from '../../types';

type OnSmartLinkUsageFetchSuccessArgs = {
	cloudId: string;
	productCount: number;
	usages?: Record<string, number>;
};

// Fires when the Smart Link usage data is successfully fetched from the TAP delivery API
export const onSmartLinkUsageFetchSuccess = ({
	cloudId,
	productCount,
	usages,
}: OnSmartLinkUsageFetchSuccessArgs): FireAnalyticsEvent => {
	return {
		action: 'taskSuccess',
		actionSubject: 'smartLinkUsageFetch',
		eventType: 'operational',
		attributes: {
			additionalAttributes: {
				cloudId,
				productCount,
				usages: usages ? JSON.stringify(usages) : undefined,
			},
		},
	};
};

type OnSmartLinkUsageFetchFailArgs = {
	cloudId: string;
	reason: string;
};

// Fires when the Smart Link usage data fetch from the TAP delivery API fails
export const onSmartLinkUsageFetchFail = ({
	cloudId,
	reason,
}: OnSmartLinkUsageFetchFailArgs): FireAnalyticsEvent => {
	return {
		action: 'taskFail',
		actionSubject: 'smartLinkUsageFetch',
		eventType: 'operational',
		attributes: {
			additionalAttributes: {
				cloudId,
				reason,
			},
		},
	};
};
